// extracted by mini-css-extract-plugin
export default {"select":"SuperSelect_select__cwXbB","icon":"SuperSelect_icon__PHg3q"};